import React, { FC } from 'react'

import { useFormContext } from 'react-hook-form'

import { TextArea, TextField } from '@/components/common/Form'
import { ContactFormData } from '@/schema/contactSchema'

type Props = {
  onFocus: () => void
}

const contactFormContent = {
  features: `可能な限り皆さんからのお声を反映したいと思います！皆さんのご意見お待ちしております！\n\n例）\nキャストの人たちに応援の声を届ける機能が欲しい。`,
  request: `貴重なご意見をいただきありがとうございます。\nこんな作品を見たい！〇〇さんに出てもらいたい！などのリクエストがあればお気軽にご連絡ください。\n制作スタッフで今後の作品の参考にさせていただきます！\n※必ずリクエストにお答えできるとは限らないのでご了承ください。\n\n例）\nドロドロの恋愛を描いた不倫ものが見たいです！\nYouTuberの〇〇さんが出ている作品を見たいです！`,
  report: `この度はご迷惑をおかけしてしまい、大変申し訳ございませんでした。\nサービス改善のために不具合の詳細をご記入いただけますと幸いです。\n回答はいただいたメールアドレスにお送りいたしますので、忘れずにご記入ください。\n\n例）\n不具合の内容：動画が途中で止まる\n見ていた作品：我が愛しの殺人鬼エピソード3\n不具合の頻度：毎回\nその他：音声も少し聞き取りにくいです。`,
  question: `BUMPを利用するにあたり、ご不明点などがありましたらお気軽にお問合せください。\n回答はいただいたメールアドレスにお送りいたしますので、忘れずにご記入ください。\n\n運営スタッフが回答させていただきます。\n回答まで3〜5営業日ほどお時間をいただく場合がございますのでご了承ください。`,
  offerWall: '',
  deleteUser: '',
  other: `その他お気軽にお問合せください。\n回答はいただいたメールアドレスにお送りいたしますので、忘れずにご記入ください。\n\n運営スタッフが回答させていただきます。\n回答まで3〜5営業日ほどお時間をいただく場合がございますのでご了承ください。`,
}

export const EachContactTypeForm: FC<Props> = ({ onFocus }) => {
  const {
    watch,
    register,
    formState: { errors },
  } = useFormContext<ContactFormData>()

  const placeholderRef = React.useRef<HTMLLabelElement>(null)

  const [height, setHeight] = React.useState<number | undefined>(0)

  const addNewLine = (txt: string) => {
    return txt?.split(/(\n)/g).map(t => {
      return t === '\n' ? <br /> : t
    })
  }
  const selectedContactType = watch('contactType')

  React.useEffect(() => {
    const placeholderHeight = placeholderRef?.current?.offsetHeight
    setHeight(
      typeof placeholderHeight === 'number' ? placeholderHeight + 10 : 0
    )
  }, [selectedContactType])

  return (
    <div className="py-8">
      {Object.keys(contactFormContent).includes(selectedContactType) ? (
        <div className="relative">
          <TextArea
            error={errors?.body?.message}
            register={register('body')}
            onFocus={onFocus}
            style={{ height }}
          />
          <label
            ref={placeholderRef}
            className={`${
              typeof watch('body') === 'undefined' || watch('body') === ''
                ? 'block absolute top-2 px-[10px] pt-8 text-placeholder pointer-events-none'
                : 'hidden'
            }`}
          >
            {addNewLine(contactFormContent[selectedContactType])}
          </label>
        </div>
      ) : null}
      {selectedContactType && selectedContactType !== 'offerWall' ? (
        <TextField
          label="メールアドレス"
          type="email"
          wrapperProps={{ className: 'py-8' }}
          error={errors?.userEmail?.message}
          required
          {...register('userEmail')}
        />
      ) : null}
    </div>
  )
}
